import { DoorFront, GroupAdd } from '@mui/icons-material'
import { Box, Button, TextField, Typography, Zoom } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { API_ACCESS_KEY, API_REFRESH_KEY } from 'constants/common'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { get, mapOperationsToDispatchProps, post } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

interface OwnProps {
  openRegister: boolean
  setOpenRegister: (_: boolean) => void
}

interface TokenResponse {
  access: string
  refresh: string
  email?: string
  password?: string
}

type AppProps = StateProps & DispatchProps & OwnProps

const NivosLoginFC: React.FC<any> = (props: AppProps) => {
  const { user, operations, openRegister, setOpenRegister } = props
  const navigator = useNavigate()

  const [formValues, setFormValues] = React.useState({
    email: '',
    password: ''
  })

  const [formErrors, setFormErrors] = React.useState({
    email: false,
    password: false
  })

  const _submitLogin = (): void => {
    void post('/account/token/', formValues).then((data: TokenResponse) => {
      if (data?.access !== undefined) {
        localStorage.setItem(API_ACCESS_KEY, data.access)
        localStorage.setItem(API_REFRESH_KEY, data.refresh)

        void get('/account/profile/').then(profileData => {
          const userData = {
            ...profileData[0],
            authenticated: true
          }
          operations.user.set(userData)
          navigator('/dashboard')
        })
      } else {
        setFormErrors({ password: true, email: true })
      }
    })
  }

  React.useEffect(() => {
    if (localStorage.getItem(API_ACCESS_KEY) === null) {
      operations.user.set({ ...user, authenticated: false })
      navigator('/')
    } else if (localStorage.getItem(API_ACCESS_KEY) !== null && user.id === 0) {
      void get('/account/profile/').then(profileData => {
        if (profileData.length > 0) {
          const userData = {
            ...profileData[0],
            authenticated: true
          }
          operations.user.set(userData)
        }
      })
    }
  }, [])

  return (
    <Zoom in={!openRegister} unmountOnExit>
      <Box
        width={0.75}
        paddingTop={4}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
      >
        <Zoom in={true} timeout={1250}>
          <Typography align={'center'} variant={'h2'}>
            Nivos
          </Typography>
        </Zoom>
        <Zoom in={true} timeout={2500}>
          <Typography align={'center'} paddingBottom={4}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce a mi
            vehicula, porttitor nisi in.
          </Typography>
        </Zoom>
        <Zoom in={true} timeout={3000}>
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-evenly'}
          >
            {user.authenticated !== undefined && !user.authenticated && (
              <>
                <Box marginBottom={3}>
                  <TextField
                    fullWidth
                    autoComplete={'off'}
                    label={'E-mail'}
                    sx={{ marginBottom: 3 }}
                    value={formValues.email}
                    error={formErrors.email}
                    onChange={event => {
                      setFormValues({
                        ...formValues,
                        email: event.currentTarget.value
                      })
                      setFormErrors({ ...formErrors, email: false })
                    }}
                  />
                  <TextField
                    fullWidth
                    autoComplete={'off'}
                    label={'Password'}
                    type={'password'}
                    value={formValues.password}
                    error={formErrors.password}
                    onChange={event => {
                      setFormValues({
                        ...formValues,
                        password: event.currentTarget.value
                      })
                      setFormErrors({ ...formErrors, password: false })
                    }}
                  />
                </Box>
                <Button
                  variant={'contained'}
                  size={'large'}
                  endIcon={<DoorFront fontSize={'large'} />}
                  onClick={() => _submitLogin()}
                  style={{
                    marginBottom: 15
                  }}
                >
                  Enter Nivos
                </Button>
                <Button
                  variant={'outlined'}
                  size={'large'}
                  endIcon={<GroupAdd fontSize={'large'} />}
                  onClick={() => setOpenRegister(true)}
                >
                  Register
                </Button>
              </>
            )}
            {user.authenticated !== undefined && user.authenticated && (
              <Box>
                <Typography align={'center'} sx={{ marginBottom: 5 }}>
                  Hi {user.firstName}! Welcome to <strong>Nivos</strong>
                </Typography>
                <Button
                  fullWidth
                  variant={'contained'}
                  size={'large'}
                  endIcon={<DoorFront fontSize={'large'} />}
                  onClick={() => navigator('/dashboard')}
                >
                  Enter Nivos
                </Button>
              </Box>
            )}
          </Box>
        </Zoom>
      </Box>
    </Zoom>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const NivosLogin = connect(
  mapStateToProps,
  mapDispatchToProps
)(NivosLoginFC as React.FC<OwnProps>)

export default NivosLogin
